import React from 'react';
import { useLocation } from 'react-router-dom';

import Alert from '../../styled-components/components/Alert';
import { Link } from '../../styled-components/components/Link';
import { getDealerAdminLink } from '../../utils/dealerAdminLink';

// Points people to the admin section of Dealer, which is replacing admin-ui page by page
const DealerAdminBanner = () => {
  const { pathname } = useLocation();
  const link = getDealerAdminLink(pathname);

  if (!link) {
    return null;
  }

  return (
    <div className="m-b">
      <Alert>
        {link.status === 'available' ? (
          <>
            Admin is moving to Dealer, and this page is already there. Please use it in Dealer
            instead.{' '}
            <Link href={link.url} target="_blank" rel="noopener noreferrer">
              Open in Dealer
            </Link>
          </>
        ) : (
          <>Admin is moving to Dealer. This page isn&apos;t in Dealer yet, so keep using it here.</>
        )}
      </Alert>
    </div>
  );
};

export default DealerAdminBanner;
